import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {KlikProvider} from '@lego/klik-ui';

ReactDOM.render(
  <React.StrictMode>
    <KlikProvider includeFont={true}>
      <App />
    </KlikProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
